let curriculum = {};
export const setCurriculum = (c) => { curriculum = c; };
export const getCurriculum = () => curriculum;

let audioMap = {};
export const setAudioMap = (a) => { audioMap = a; };
export const getAudioMap = () => audioMap;

let imageMap = {};
export const setImageMap = (i) => { imageMap = i; };
export const getImageMap = () => imageMap;

export const getLevelData = level => curriculum.levels.find(l => l.levelId === (level));
export const getPracticeIndices = () => {
  const allGraphemes = Object.keys(curriculum.graphemes);
  return allGraphemes.reduce((acc, grapheme) => (
    {
      ...acc,
      [grapheme]: 0,
    }
  ), {});
};
export const getGraphemeData = grapheme => curriculum.graphemes[grapheme];
export const getOnboardingGraphemes = () => curriculum.onboardingGraphemes.map(grapheme => grapheme.questionId);

export const getLevelGrapheme = (level, progress, numQuestions) => {
  const levelData = getLevelData(level);
  const question = levelData.questions[progress % numQuestions];
  return question.correctResponseId;
};

export const getCurriculumKeys = () => {
  const curriculumKeys = {};

  curriculum.levels.forEach(level => level.options.forEach((option) => {
    const {
      instructionWord,
      practice1TargetPicture1,
      practice1TargetPicture2,
      practice1TargetPicture3,
      practice1TargetPicture4,
      practice1DistractorPicture1,
      practice1DistractorPicture2,
      practice2TargetPicture1,
      practice2TargetPicture2,
      practice2TargetPicture3,
      practice2TargetPicture4,
      practice2DistractorPicture1,
      practice2DistractorPicture2,
      practice3TargetPicture1,
      practice3TargetPicture2,
      practice3TargetPicture3,
      practice3TargetPicture4,
      practice3DistractorPicture1,
      practice3DistractorPicture2,
    } = curriculum.graphemes[option.questionId];

    const assetKeys = [
      instructionWord,
      practice1TargetPicture1,
      practice1TargetPicture2,
      practice1TargetPicture3,
      practice1TargetPicture4,
      practice1DistractorPicture1,
      practice1DistractorPicture2,
      practice2TargetPicture1,
      practice2TargetPicture2,
      practice2TargetPicture3,
      practice2TargetPicture4,
      practice2DistractorPicture1,
      practice2DistractorPicture2,
      practice3TargetPicture1,
      practice3TargetPicture2,
      practice3TargetPicture3,
      practice3TargetPicture4,
      practice3DistractorPicture1,
      practice3DistractorPicture2,
    ];

    curriculumKeys[`level${level.levelId}`] = assetKeys;
  }));

  return curriculumKeys;
};
